import { render, staticRenderFns } from "./brandAuthorizingEdit.vue?vue&type=template&id=194442a4&scoped=true&"
import script from "./brandAuthorizingEdit.vue?vue&type=script&lang=js&"
export * from "./brandAuthorizingEdit.vue?vue&type=script&lang=js&"
import style0 from "./brandAuthorizingEdit.vue?vue&type=style&index=0&id=194442a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194442a4",
  null
  
)

export default component.exports